module.exports = __webpack_public_path__ + "static/img/banner2.9bbec1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/banner2.jpg
// module id = v9KI
// module chunks = 12